/*
 * The connect actions a credential closed after the newest run on the thread started: an app the
 * person connected somewhere else (the Connections page, the Full Service portal) that Pieve has not
 * worked with yet. The credential funnel no longer restarts the thread (owner decision D1,
 * 2026-10-02), so this is what tells the person there is something to continue with. Same boundary as
 * listPieveWorkflowUnseenAnswers. The funnel records a client's own portal connection `by: 'portal'`
 * and every other one as the mirror; both are connections here.
 */
const CONNECT_KINDS = new Set(['connect', 'reconnect']);
const CONNECTION_CLOSERS = new Set(['mirror:credential_valid', 'portal']);

const listPieveWorkflowUnseenConnections = ({ actions = [], latestRunStartedOn = null } = {}) => {
  const boundaryMs = Date.parse(String(latestRunStartedOn || ''));

  return (Array.isArray(actions) ? actions : []).filter((action) => {
    const closed = Array.isArray(action?.history) ? action.history.at(-1) : null;
    const closedMs = Date.parse(String(closed?.on || ''));

    return action?.status === 'done' && CONNECT_KINDS.has(action?.kind) && closed?.status === 'done' && CONNECTION_CLOSERS.has(closed?.by) && Number.isFinite(closedMs) && (!Number.isFinite(boundaryMs) || closedMs > boundaryMs);
  });
};

export default listPieveWorkflowUnseenConnections;
